export default __webpack_public_path__ + "static/media/539.05fe07ca.png";